// ─── Import Local Images ──────────────────────────────────
import coreBankingImg from '@assets/corebanking.png';
import erpSolutionsImg from '@assets/erpystems.png';
import hospitalManagementImg from '@assets/hospitalmanagement.png';
import queueManagementImg from '@assets/hospitalmanagement.png';
import schoolManagementImg from '@assets/healthcaresystems.png';
import hrPayrollImg from '@assets/hrpayroll.png';
import paymentIntegrationImg from '@assets/bankintegration.png';
import mpsEftSwitchImg from '@assets/bankintegration.png';
import mpesaPaybillImg from '@assets/mobilemoney.png';
import mobileBankingImg from '@assets/mobilebanking.png';
import bulkSmsPlatformImg from '@assets/mobilebanking.png';
import aiTrainingImg from '@assets/aitraining.png';
import customSoftwareImg from '@assets/aitraining.png';
import bankIntegrationImg from '@assets/bankintegration.png';

export const productsData = [
  // ===== CORE BANKING / POWER FINANCIALS =====
  {
    id: 'power-financials',
    name: 'Power Financials',
    slug: 'power-financials',
    category: 'Core Banking',
    description: 'Full-featured core banking and SACCO management system built for African financial institutions. This is our comprehensive core banking solution for managing SACCOs, microfinance institutions, and banks.',
    features: [
      'Member Account Management',
      'Savings & Fixed Deposit Processing',
      'Loan Origination & Disbursement',
      'Share Capital Management',
      'Dividend & Interest Calculations',
      'M-PESA & Mobile Money Integration',
      'Real-time Financial Reporting',
      'Audit Trail & Compliance Reporting',
      'Member Portal & USSD Integration'
    ],
    image: coreBankingImg,
    industries: ['SACCOs', 'Microfinance', 'Banks', 'Credit Unions', 'NGOs'],
    integrations: ['M-PESA', 'Bank APIs', 'Mobile Apps', 'USSD', 'SMS Gateways']
  },

  // ===== ERP - MICROSOFT DYNAMICS 365 =====
  {
    id: 'dynamics-365',
    name: 'Microsoft Dynamics 365 Business Central',
    slug: 'dynamics-365',
    category: 'ERP',
    description: 'Enterprise resource planning solution from Microsoft (formerly known as Dynamics NAV). Delivers comprehensive business management functionality for your entire enterprise including financials, supply chain, and operations.',
    features: [
      'Financial Management',
      'Supply Chain Management',
      'Operations Management',
      'Business Intelligence',
      'Reporting & Analytics',
      'Inventory Management',
      'Procurement Management',
      'Project Management',
      'Human Resource Management',
      'Sales & Marketing',
      'Warehouse Management',
      'Manufacturing'
    ],
    image: erpSolutionsImg,
    industries: ['SMEs', 'Manufacturing', 'Distribution', 'Services', 'Retail'],
    integrations: ['Microsoft Azure', 'Power BI', 'Office 365', 'Third-party APIs']
  },

  // ===== HOSPITAL MANAGEMENT =====
  {
    id: 'hospital-management',
    name: 'Hospital Management System',
    slug: 'hospital-management',
    category: 'Healthcare',
    description: 'Comprehensive hospital management system with EMR, billing, patient records, and laboratory integration.',
    features: [
      'Electronic Medical Records (EMR)',
      'Patient Registration & Management',
      'Appointment Scheduling',
      'Billing & Invoicing',
      'Laboratory & Pharmacy Integration',
      'Stock & Inventory Management',
      'Insurance & Claims Management',
      'Doctor & Nurse Management',
      'Radiology & Imaging Integration',
      'Patient Portal & Online Booking'
    ],
    image: hospitalManagementImg,
    industries: ['Hospitals', 'Clinics', 'Medical Centers', 'Healthcare Providers'],
    integrations: ['SMS Gateways', 'Payment Gateways', 'Lab Systems', 'Pharmacy Systems']
  },
  {
    id: 'queue-management',
    name: 'Queue Management System',
    slug: 'queue-management',
    category: 'Healthcare',
    description: 'Digital queue management for hospitals and service-oriented organizations ensuring efficient patient flow.',
    features: [
      'Patient Flow Management',
      'Service Analytics',
      'SMS Notifications',
      'Self-Service Kiosks',
      'Staff Performance Tracking',
      'Real-time Dashboard',
      'Appointment Integration',
      'Wait Time Estimation'
    ],
    image: queueManagementImg,
    industries: ['Hospitals', 'Banks', 'Government Offices', 'Retail', 'Clinics'],
    integrations: ['SMS Gateways', 'Display Systems', 'Mobile Apps', 'POS Systems']
  },

  // ===== SCHOOL MANAGEMENT =====
  {
    id: 'school-management',
    name: 'School Management System',
    slug: 'school-management',
    category: 'Education',
    description: 'Complete school management system for admissions, examinations, fee processing, and parent communication.',
    features: [
      'Student Registration & Records',
      'Class & Timetable Management',
      'Examination & Grading System',
      'Fee Processing & Invoicing',
      'Parent & Teacher Communication',
      'Attendance Tracking',
      'Library Management',
      'Transport Management',
      'Staff & Payroll Management',
      'Report Card Generation'
    ],
    image: schoolManagementImg,
    industries: ['Schools', 'Colleges', 'Universities', 'Educational Institutions'],
    integrations: ['SMS Gateways', 'Payment Gateways', 'Parent Apps', 'Learning Management Systems']
  },

  // ===== HR & PAYROLL =====
  {
    id: 'hr-payroll',
    name: 'HR & Payroll Management',
    slug: 'hr-payroll',
    category: 'HR',
    description: 'Complete HR management including payroll, leave, claims, tax, and performance tracking.',
    features: [
      'Payroll Processing',
      'Leave Management',
      'Claims Management',
      'Tax Management',
      'Performance Tracking',
      'Employee Database',
      'Attendance Management',
      'Staff Recruitment'
    ],
    image: hrPayrollImg,
    industries: ['All Industries'],
    integrations: ['Bank APIs', 'Tax Systems', 'HR Systems', 'Payroll Services']
  },

  // ===== BANK INTEGRATION PLATFORM =====
  {
    id: 'bank-integration',
    name: 'Payment Integration Platform',
    slug: 'payment-integration-platform',
    category: 'Integration',
    description: 'Connect your financial systems to banks, payment channels and financial service platforms. Micropoint develops secure integration solutions connecting financial institutions with banks, mobile money platforms, payment services and third-party financial systems—automating transaction flows, notifications, collections and reconciliation.',
    features: [
      'Bank API Integration',
      'Real-Time Transaction Notifications',
      'M-PESA Integration',
      'Payment Collections',
      'Automated Reconciliation',
      'Bank Statement Integration',
      'Payment Gateway Integration',
      'Remote Cheque Scanning & Clearing Workflows',
      'CRB Integration',
      'Transaction Monitoring',
      'ATM / POS Integration',
      'Mobile Money Integration'
    ],
    image: bankIntegrationImg,
    industries: ['Microfinance Institutions', 'SACCOs', 'Financial Institutions', 'Fintechs', 'Payment Services'],
    integrations: [
      'NCBA Bank',
      'Co-operative Bank',
      'Family Bank',
      'Equity Bank',
      'KCB',
      'Metropol CRB',
      'M-PESA',
      'Bank APIs',
      'ATM Networks',
      'POS Systems',
      'Payment Gateways'
    ],
    integrationExperience: [
      { 
        name: 'NCBA Bank', 
        status: 'completed', 
        description: 'Account-level transaction notification / push integration'
      },
      { 
        name: 'Co-operative Bank', 
        status: 'completed', 
        description: 'Remote cheque scanning / cheque truncation integration workflow'
      },
      { 
        name: 'Family Bank', 
        status: 'completed', 
        description: 'Cheque truncation solution delivered for DIMKES SACCO'
      },
      { 
        name: 'Equity Bank', 
        status: 'attempted', 
        description: 'Integration work attempted in connection with Kwale County'
      },
      { 
        name: 'KCB', 
        status: 'ongoing', 
        description: 'Integration currently being finalized'
      },
      { 
        name: 'Metropol CRB', 
        status: 'completed', 
        description: 'Credit reference integration supporting identity verification, delinquency checks, credit scores and credit reports'
      }
    ],
    whyChoose: [
      {
        title: 'Built Around Your Workflow',
        description: 'We integrate banking and payment services into the way your financial operation actually works.'
      },
      {
        title: 'Proven Financial Integrations',
        description: 'Experience connecting financial systems with banks, mobile money platforms, payment services and credit reference platforms.'
      },
      {
        title: 'Reconciliation by Design',
        description: 'Validation, transaction matching, automated posting and reconciliation help reduce manual processing and unmatched transactions.'
      },
      {
        title: 'End-to-End Transaction Visibility',
        description: 'Monitor transactions in real-time across all connected banks and payment channels with instant notifications and alerts.'
      }
    ],
    integrationFlow: [
      'Customer / Member initiates transaction',
      'Bank / M-PESA / Payment Channel processes transaction',
      'Micropoint Integration Layer receives transaction',
      'Validation & Transaction Matching occurs',
      'Client Financial System receives matched transaction',
      'Posting & Reconciliation completes the workflow'
    ],
    selectedSolutions: [
      {
        title: 'Bank Transaction Notifications',
        description: 'Bank debit and credit transactions can be delivered to client endpoints for automated processing.'
      },
      {
        title: 'Payment Collections & Reconciliation',
        description: 'Connect payment channels so collections are matched to the correct member/customer account, with unmatched transactions routed for review.'
      },
      {
        title: 'Remote Cheque Scanning',
        description: 'Transmit cheque images securely to a bank for clearing and support posting of cleared transactions back into the recipient ERP.'
      },
      {
        title: 'Credit Reference Integration',
        description: 'Connect financial systems to CRB services for identity verification, delinquency checks, credit scoring and credit reports.'
      }
    ]
  },

  // ===== PAYMENT INTEGRATION (Legacy - Keeping for compatibility) =====
  {
    id: 'payment-integration',
    name: 'Payment Integration Platform',
    slug: 'payment-integration',
    category: 'Payments',
    description: 'Connect your financial systems to banks, payment channels and financial service platforms. Secure integration solutions connecting financial institutions with banks, mobile money platforms, payment services and third-party financial systems—automating transaction flows, notifications, collections and reconciliation.',
    features: [
      'Bank API Integration',
      'Real-Time Transaction Notifications',
      'M-PESA Integration',
      'Payment Collections',
      'Automated Reconciliation',
      'Bank Statement Integration',
      'Payment Gateway Integration',
      'Remote Cheque Scanning & Clearing Workflows',
      'CRB Integration',
      'Transaction Monitoring',
      'ATM / POS Integration',
      'Mobile Money Integration'
    ],
    image: paymentIntegrationImg,
    industries: ['Microfinance Institutions', 'SACCOs', 'Financial Institutions', 'Fintechs', 'Payment Services'],
    integrations: [
      'NCBA Bank',
      'Co-operative Bank',
      'Family Bank',
      'Equity Bank',
      'KCB',
      'Metropol CRB',
      'M-PESA',
      'Bank APIs',
      'ATM Networks',
      'POS Systems',
      'Payment Gateways'
    ]
  },
  {
    id: 'mps-eft-switch',
    name: 'MPS EFT Switch',
    slug: 'mps-eft-switch',
    category: 'Payments',
    description: 'Payment switching and transaction processing platform using ISO 8583 Standard for POS, ATM, and Mobile Banking.',
    features: [
      'ISO8583 Switching',
      'ATM Integration',
      'POS Integration',
      'Card Management',
      'Transaction Routing',
      'Mobile Banking Connectivity'
    ],
    image: mpsEftSwitchImg,
    industries: ['Banks', 'Microfinance', 'Payment Processors'],
    integrations: ['ATM Networks', 'POS Systems', 'Card Schemes', 'Mobile Banking']
  },
  {
    id: 'mpesa-paybill',
    name: 'MPESA Pay Bill Solution',
    slug: 'mpesa-paybill',
    category: 'Payments',
    description: 'Seamless integration to Power Financials Software where customers can deposit or withdraw money from their mobile phones.',
    features: [
      'B2C Withdrawals',
      'C2B Deposits',
      'Real-time Integration',
      'Transaction Monitoring',
      'SMS Alerts',
      'Power Financials Integration'
    ],
    image: mpesaPaybillImg,
    industries: ['Banks', 'SACCOs', 'Microfinance', 'Fintech'],
    integrations: ['M-PESA', 'Power Financials', 'Bank APIs', 'SMS Gateways']
  },

  // ===== MOBILE PRODUCTS =====
  {
    id: 'mobile-banking',
    name: 'Mobile Banking Platform',
    slug: 'mobile-banking',
    category: 'Mobile',
    description: 'Complete mobile banking solution including USSD, Android Apps, Agency Banking, and Wallet Integration.',
    features: [
      'USSD Banking',
      'Android App',
      'iOS App',
      'Agency Banking',
      'Wallet Integration',
      'Mobile Payments',
      'Push Notifications',
      'Biometric Authentication',
      'Funds Transfer',
      'Bill Payments',
      'Transaction History'
    ],
    image: mobileBankingImg,
    industries: ['Banks', 'SACCOs', 'Microfinance', 'Fintech'],
    integrations: ['Core Banking', 'M-PESA', 'Payment Gateways', 'SMS Gateways']
  },

  // ===== COMMUNICATION PRODUCTS =====
  {
    id: 'bulk-sms-platform',
    name: 'Bulk SMS Platform',
    slug: 'bulk-sms-platform',
    category: 'Communication',
    description: 'Enterprise bulk SMS solutions with SIM-card based and internet-based options for effective communication.',
    features: [
      'SIM-Card Based SMS',
      'Internet Based SMS',
      'Bulk SMS Sending',
      'Message Scheduling',
      'Contact Management',
      'Two-way SMS',
      'Reply Handling',
      'Analytics & Reporting'
    ],
    image: bulkSmsPlatformImg,
    industries: ['All Industries'],
    integrations: ['SMS Gateways', 'CRM Systems', 'Mobile Networks', 'Marketing Platforms']
  },

  // ===== AI & TRAINING =====
  {
    id: 'ai-training',
    name: 'AI Solutions & Training',
    slug: 'ai-training',
    category: 'AI',
    description: 'Artificial Intelligence solutions and training programs for business automation and innovation.',
    features: [
      'AI Consulting & Strategy',
      'Machine Learning Solutions',
      'Business Process Automation',
      'Data Analytics & Insights',
      'Custom AI Model Development',
      'AI Training Programs',
      'Chatbot Development',
      'Predictive Analytics'
    ],
    image: aiTrainingImg,
    industries: ['All Industries'],
    integrations: ['Cloud Platforms', 'APIs', 'Business Systems', 'Data Sources']
  },

  // ===== CUSTOM SOFTWARE =====
  {
    id: 'custom-software',
    name: 'Custom Software Development',
    slug: 'custom-software',
    category: 'Custom',
    description: 'Tailored software solutions built to meet your specific business requirements.',
    features: [
      'Custom Application Development',
      'System Integration',
      'Legacy System Modernization',
      'Cloud Migration',
      'Web Application Development',
      'Mobile App Development',
      'API Development',
      'Technical Consulting'
    ],
    image: customSoftwareImg,
    industries: ['All Industries'],
    integrations: ['Third-party APIs', 'Cloud Services', 'Business Systems', 'Databases']
  }
];

// Helper functions
export const getProductsByCategory = (category) => {
  return productsData.filter(product => product.category === category);
};

export const getAllCategories = () => {
  const categories = [...new Set(productsData.map(product => product.category))];
  return categories;
};

export const getCategoryIcon = (category) => {
  const icons = {
    'Core Banking': '🏦',
    'ERP': '📊',
    'Payments': '💳',
    'HR': '👥',
    'Automation': '🤖',
    'Mobile': '📱',
    'Communication': '📨',
    'Integration': '🔗',
    'Healthcare': '🏥',
    'Education': '🎓',
    'AI': '🤖',
    'Custom': '⚙️'
  };
  return icons[category] || '📦';
};

export const getCategoryGradient = (category) => {
  const gradients = {
    'Core Banking': 'from-amber-500 to-orange-500',
    'ERP': 'from-blue-500 to-indigo-500',
    'Payments': 'from-emerald-500 to-teal-500',
    'HR': 'from-purple-500 to-pink-500',
    'Automation': 'from-cyan-500 to-blue-500',
    'Mobile': 'from-green-500 to-emerald-500',
    'Communication': 'from-yellow-500 to-amber-500',
    'Integration': 'from-indigo-500 to-purple-500',
    'Healthcare': 'from-red-500 to-rose-500',
    'Education': 'from-sky-500 to-blue-500',
    'AI': 'from-fuchsia-500 to-pink-500',
    'Custom': 'from-gray-500 to-gray-600'
  };
  return gradients[category] || 'from-gray-500 to-gray-600';
};